import {Component, Input} from '@angular/core';
import {Icons} from '../../../../global';
import {InputAbstract} from '../base/input.abstract';
import { MatFormField, MatLabel, MatPrefix, MatSuffix, MatHint, MatError } from '@angular/material/form-field';
import { NgIf } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepickerToggleIcon, MatDatepicker } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'slm-date-input',
    templateUrl: './date-input.component.html',
    styles: [`
    :host {
      flex-direction: row;
      box-sizing: border-box;
      display: flex;
    }
  `],
    imports: [MatFormField, NgIf, MatLabel, TranslateDirective, SvgIconComponent, MatPrefix, MatInput, MatDatepickerInput, FormsModule, ReactiveFormsModule, MatDatepickerToggle, MatSuffix, MatTooltip, MatDatepickerToggleIcon, MatDatepicker, MatHint, MatError, TranslatePipe]
})
export class DateInputComponent extends InputAbstract {
  @Input() public min: Date;
  @Input() public max: Date;
  @Input() public prefixIcon: Icons = null;
  @Input() public suffixIconLabel = '';
}
